"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = _interopRequireDefault(require("./constants"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function toHeaderString(value, bitLength) {
  var byteLength = bitLength / 8;
  var buf = Buffer.alloc(byteLength);

  if (byteLength == 8) {
    var low = value & 0xffffffff;
    var high = (value - low) / 0x100000000 - (low < 0 ? 1 : 0);
    buf.writeInt32LE(low, 0);
    buf.writeUInt32LE(high, 0 + 4);
  } else {
    buf.writeUIntLE(value, 0, byteLength);
  }

  return buf;
}

function headerToBuffer(header) {
  var size = 0;

  for (var key in header) {
    size += key.length;
    size += header[key].length;
    size += 4;
    size += 1;
  }

  if (size === 0) {
    return -1;
  }

  var buf = Buffer.alloc(size);

  for (var _key in header) {
    var len = _key.length + header[_key].length + 1;
    var tmp = Buffer.from(header[_key]);
    var offset = buf.writeUInt32LE(len, offset);
    offset += buf.write(_key, offset);
    offset += buf.write('=', offset);
    offset += tmp.copy(buf, offset);
  }

  return buf;
}

function timeToBuffer(time) {
  var buf = Buffer.alloc(8);
  buf.writeUIntLE(time.sec, 0, 4);
  buf.writeUIntLE(time.nsec, 4, 4);
  return buf;
}

function appendConnectionRecordToBuffer(buf, connectionInfo) {
  var _header;

  var header = (_header = {}, _defineProperty(_header, _constants["default"].OP_FIELD_NAME, toHeaderString(_constants["default"].OP_CONNECTION, 8)), _defineProperty(_header, _constants["default"].TOPIC_FIELD_NAME, connectionInfo.topic), _defineProperty(_header, _constants["default"].CONNECTION_FIELD_NAME, toHeaderString(connectionInfo.id, 32)), _header);
  buf = appendHeaderToBuffer(buf, header);
  buf = appendHeaderToBuffer(buf, connectionInfo.header);
  return buf;
}

function appendHeaderToBuffer(buf, header) {
  var headerBuffer = headerToBuffer(header);
  var len = headerBuffer.length;
  return Buffer.concat([buf, toHeaderString(len, 32), headerBuffer]);
}

function appendDataLengthToBuffer(buf, dataLength) {
  return Buffer.concat([buf, toHeaderString(dataLength, 32)]);
}

var _default = {
  toHeaderString: toHeaderString,
  headerToBuffer: headerToBuffer,
  timeToBuffer: timeToBuffer,
  appendConnectionRecordToBuffer: appendConnectionRecordToBuffer,
  appendHeaderToBuffer: appendHeaderToBuffer,
  appendDataLengthToBuffer: appendDataLengthToBuffer
};
exports["default"] = _default;